import React, { useEffect, useState } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'
import { templateJson } from './json/templateJson'
// import { useParams } from 'react-router-dom'
// import ShareBtn from './ShareBtn'
import Cookies from 'js-cookie'

const SuccessComputex = () => {
  // let { pid } = useParams()
  useEffect(() => {
    if (!Cookies.get('hasReceivedAward')) {
      Cookies.set('hasReceivedAward', 'false', {
        expires: 4,
        secure: true,
        sameSite: 'strict',
      })
    }
  }, [])
  console.log('Cookies.get()', Cookies.get('hasReceivedAward'))

  // console.log('shareUrl', shareUrl)
  // const completionMessage=''
  const [mySuccessJson, setMySuccessJson] = useState(null)
  const outerUrl = `<h3>感謝您的蒞臨參觀</h3><h3>We're honored to have you visiting us!</h3><h4>Beyond SMART+, it's AI NOW!</h4><h4><a href='https://www.benq.com/zh-tw/index.html?gad_source=1&gclid=CjwKCAjw3NyxBhBmEiwAyofDYTj1FZIhIcNQurZ02Sly1AZ56xxGQA56JUvYW34sYYHHWEt4_onCDxoC-N0QAvD_BwE'
  >BenQ website</a></h4><h4><a href='https://www.qisda.com/tw'>Qisda website</a></h4></h4><h4><a href='https://www.youtube.com/@QisdaCorp'>Qisda Youtube</a></h4>`
  useEffect(() => {
    if (Cookies.get('hasReceivedAward') === 'true') {
      setMySuccessJson({
        ...templateJson,
        logo: 'https://i.postimg.cc/D05qPdfm/banner-4x.png',
        title: '【2024 COMPUTEX】BenQ SMART+ AI NOW',
        completeText: '完成',
        completedHtml: outerUrl,
        pages: [
          {
            name: 'page0',
            elements: [
              {
                type: 'panel',
                elements: [
                  {
                    type: 'html',
                    name: 'intro',
                    html: `<h4 style='text-align: center'>問卷已成功送出</h4><h4 style='text-align: center'>The questionnaire has been successfully submitted.</h4>`,
                  },
                ],
                name: 'panel1',
              },
            ],
          },
        ],
      })
    } else {
      setMySuccessJson({
        ...templateJson,
        logo: 'https://i.postimg.cc/D05qPdfm/banner-4x.png',
        title: '【2024 COMPUTEX】BenQ SMART+ AI NOW',
        completeText: '確認兌獎',
        completedHtml: outerUrl,
        pages: [
          {
            name: 'page0',
            elements: [
              {
                type: 'panel',
                elements: [
                  {
                    type: 'html',
                    name: 'intro',
                    html: '感謝您的填寫，憑問卷完成畫面，可至BenQ服務台兌換禮品一份(每人限領一次)。<br />Thank you for completing the survey. Please present the completion screen at the BenQ Information Desk to redeem a gift (limited to one per person).',
                  },
                  {
                    type: 'text',
                    name: 'gift',
                    title:
                      '請向「BenQ 服務台人員」出示此畫面 Please show this screen to BenQ Information Desk staff.',
                  },
                ],
                name: 'panel1',
              },
            ],
          },
        ],
      })
    }
  }, [])

  function onSurveyValidateQuestion(survey, options) {
    if (options.name === 'gift') {
      if (options.value !== 'aaa') {
        options.error = '請輸入正確兌獎密碼才能提交 Please enter password'
      } else if (options.value === 'aaa') {
        Cookies.set('hasReceivedAward', 'true', {
          expires: 4,
          secure: true,
          sameSite: 'strict',
        })
      } else {
      }
    }
  }

  // let mySuccessJson = {
  //   ...templateJson,
  //   completeText: '提交兌獎密碼',
  //   completedHtml: `<h3>感謝您的參與</h3><a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href='https://www.benq.com/zh-tw/index.html?gad_source=1&gclid=CjwKCAjw3NyxBhBmEiwAyofDYTj1FZIhIcNQurZ02Sly1AZ56xxGQA56JUvYW34sYYHHWEt4_onCDxoC-N0QAvD_BwE'
  //   >BenQ官網</a>`,
  //   pages: [
  //     {
  //       name: 'page0',
  //       elements: [
  //         {
  //           type: 'panel',
  //           elements: [
  //             {
  //               type: 'html',
  //               name: 'intro',
  //               html: completionMessage,
  //             },
  //           ],
  //           name: 'panel1',
  //         },
  //       ],
  //     },
  //   ],
  // }
  const survey = new Model(mySuccessJson)
  survey.onValidateQuestion.add(onSurveyValidateQuestion)

  return (
    <>
      <Survey model={survey} />
    </>
  )
}

export default SuccessComputex
